var flowStatusArr = [
    {
        status:1,
        message:'发起申请'
    },
    {
        status:2,
        message:'信息审核通过'
    },
    {
        status:3,
        message:'上传完稿文件'
    },
    {
        status:4,
        message:'确认验收'
    },
    {
        status:5,
        message:'完成流程'
    },
    {//审核信息拒绝
        status:-1,
        message:'信息审核未通过'
    },
    {//撤销
        status:-2,
        message:'已撤销'
    },
    {//需求变更
        status:-3,
        message:'需求变更'
    },
    {//验收被拒
        status:-4,
        message:'验收未通过'
    },
   
]
export {
    flowStatusArr
}